import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "@/assets/brand/logo.svg";
import logoDark from "@/assets/brand/logo-oscuro.svg";
import "./assets/scss/style.scss";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/900.css";
import "@fontsource/roboto-mono/400.css";
import "@fontsource/roboto-mono/500.css";
import "./landing/landing.scss";
import SectionLink from "./landing/SectionLink.jsx";

/**
 * El logo de la tarjeta #13, en su versión clara y en la de fondo oscuro.
 * Van los dos y el CSS enseña uno según el modo del sistema.
 */
const Logo = ({ alt, width }) => (
  <>
    <img
      className="lp-logo lp-logo-light"
      src={logo}
      alt={alt}
      style={width ? { width } : undefined}
    />
    <img
      className="lp-logo lp-logo-dark"
      src={logoDark}
      alt=""
      aria-hidden="true"
      style={width ? { width } : undefined}
    />
  </>
);

/**
 * Marco de la parte pública: portada, login, alta y recuperación de
 * contraseña comparten el menú y el pie del demo de la tarjeta #13.
 */
const TemplateGuest = ({ content }) => {
  const { t } = useTranslation();

  return (
    <div className="lp">
      <div className="lp-navbar">
        <nav className="lp-nav">
          <SectionLink to="inicio">
            <Logo alt={t("company name")} />
          </SectionLink>
          <div className="lp-navlinks">
            <SectionLink to="quien">Para quién</SectionLink>
            <SectionLink to="panel">Tu panel</SectionLink>
            <SectionLink to="calculadora">Calculadora</SectionLink>
            <SectionLink to="precios">Paquetes</SectionLink>
            <Link className="lp-btn lp-sm" to="/dashboard">
              Aplicación
            </Link>
          </div>
        </nav>
      </div>

      <div className="lp-wrap">
        <div className="lp-content">{content}</div>

        <footer className="lp-footer">
          <Logo alt={t("company name")} width={160} />
          <span>
            {new Date().getFullYear()} © CFD-iPunto. Todos los derechos
            reservados.
          </span>
        </footer>
      </div>
    </div>
  );
};

export default TemplateGuest;
